import { render, staticRenderFns } from "./DeerTraceElements.vue?vue&type=template&id=cc0265de&"
import script from "./DeerTraceElements.vue?vue&type=script&lang=js&"
export * from "./DeerTraceElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports